var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 col-lg-3 h-100 d-flex flex-column" },
    [
      _c("div", { staticClass: "row" }, [
        _c("h3", [_vm._v("Hello " + _vm._s(_vm.user.first_name) + "!")]),
        _vm._v(" "),
        _vm.user.anonymous == "1"
          ? _c(
              "div",
              {
                staticClass: "alert alert-warning mt-3 mb-0 w-100",
                on: {
                  click: function($event) {
                    return _vm.setPage("more")
                  }
                }
              },
              [
                _vm._v("You are in anonymous mode"),
                _c("i", { staticClass: "fas fa-user-secret float-right" })
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "mood-section row flex-grow-1 mt-3" }, [
        _c("div", { staticClass: "w-100 justify-content-center" }, [
          _vm.emotions &&
          _vm.mood.mood_window &&
          _vm.mood.mood_window_id === _vm.mood.mood_window.id
            ? _c("div", { staticClass: "chatBubble mb-3" }, [
                _vm._v(
                  "You are feeling " +
                    _vm._s(
                      _vm.emotions.find(function(mood) {
                        return mood.id === _vm.selectedMood
                      }).name
                    ) +
                    "!"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.mood.mood_window &&
          _vm.mood.mood_window_id !== _vm.mood.mood_window.id
            ? _c("div", { staticClass: "chatBubble mb-3" }, [
                _vm._v(
                  "How are you feeling " +
                    _vm._s(
                      _vm.mood.mood_window.name === "Night" ? "to" : "this"
                    ) +
                    " " +
                    _vm._s(_vm.mood.mood_window.name.toLowerCase()) +
                    "?"
                )
              ])
            : _c("i", { staticClass: "mood-submitted far fa-check-circle" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center mt-0 mt-lg-5", attrs: { id: "mood" } },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.mood.mood_window &&
                      _vm.mood.mood_window_id === _vm.mood.mood_window.id,
                    expression:
                      "mood.mood_window && mood.mood_window_id === mood.mood_window.id"
                  }
                ],
                attrs: { id: "mood-touch-prevent" }
              }),
              _vm._v(" "),
              _vm.mood.mood_window &&
              _vm.mood.mood_window_id !== _vm.mood.mood_window.id
                ? _c("i", {
                    staticClass:
                      "swipe-indicator left fas fa-angle-double-left",
                    on: { click: _vm.previousMood }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.emotions && _vm.showEmoticons
                ? _c(
                    "div",
                    {
                      class: _vm.emotions && _vm.showEmoticons ? "show" : "hide"
                    },
                    [
                      _c("img", {
                        staticClass: "icon bounce",
                        staticStyle: { "touch-action": "none" },
                        attrs: {
                          id: "emotion",
                          src: require("@/assets/moods/" +
                            _vm.emotions.find(function(mood) {
                              return mood.id === _vm.selectedMood
                            }).image),
                          alt: "",
                          draggable: "false"
                        },
                        on: { click: _vm.doubleClickCheck }
                      }),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-center" }, [
                        (_vm.mood.mood_window &&
                          _vm.mood.mood_window_id !==
                            _vm.mood.mood_window.id) ||
                        _vm.mood.today === "0"
                          ? _c(
                              "span",
                              {
                                staticClass: "text-muted m-2 badge badge-light"
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.isTracking
                                        ? "You're Feeling " +
                                            _vm.emotions.find(function(mood) {
                                              return (
                                                mood.id === _vm.selectedMood
                                              )
                                            }).name
                                        : _vm.mood.today &&
                                          _vm.mood.mood_window_id === 1
                                        ? "You're Feeling " +
                                          _vm.emotions.find(function(mood) {
                                            return mood.id === _vm.selectedMood
                                          }).name
                                        : _vm.userNotSelectedMood
                                        ? "You Feel " +
                                          _vm.emotions.find(function(mood) {
                                            return mood.id === _vm.selectedMood
                                          }).name +
                                          "? Double tap to save!"
                                        : _vm.swipePromptText
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mood.mood_window &&
              _vm.mood.mood_window_id !== _vm.mood.mood_window.id
                ? _c("i", {
                    staticClass:
                      "swipe-indicator right fas fa-angle-double-right",
                    on: { click: _vm.nextMood }
                  })
                : _vm._e()
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7844d8b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7844d8b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mood.vue
// module id = null
// module chunks = 